import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {homeStoreG} from '@src/containers/viewsG/home/actor/store'
import {deviceStore} from '@views/mine/device/actor/store'
import {OPERATOR_V} from '@src/constants';

class MyDeviceStoreG extends StoreExt {
    @observable deviceList: any[] = []
    @action
    getDeviceList = async () => {
        this.showLoading()
        try {
            const res = await this.api.getDeviceList({})
            runInAction(() => {
                this.deviceList = res
            })
        } catch (e) {
        } finally {
            this.hideLoading()
        }
    }

    @action
    switchDevice = async options => {
        try {
            if (options.operatorsId === OPERATOR_V.TRUPHONE || options.operatorsId === OPERATOR_V.HUE) {
                await homeStoreG.getSimInfo(options.simId)
                await homeStoreG.getUserInfo()
                location.href = '#/global/home'
            } else {
                deviceStore.switchDevice(options.simId)
            }
        } catch (e) {
        }
    }

    @action
    editNickName = async (simId, nickName) => {
        try {
            await this.api.editSimName({simId, nickName})
            this.getDeviceList()
        } catch (e) {
        }
    }
}

const myDeviceStoreG = new MyDeviceStoreG()
export {myDeviceStoreG, MyDeviceStoreG}
